export default __webpack_public_path__ + "static/play_store_icon-eb9be2dbc4fe17a6a0b26641ec50841b.svg";